import { observer } from 'mobx-react-lite'
import React, { useState, useContext } from 'react'
import Switch from '../../../../FormComponents/Switch'
import InfluencerRowStats from './InfluencerOverviewParts/InfluencerRowStats'
import InfluencerDetails from './InfluencerOverviewParts/InfluencerDetails'
import { ChevronDown, ChevronUp, CheckCircle, DashCircle } from 'react-bootstrap-icons'
import { CampaignContext } from '../../../../../contexts/CampaignContext'

export default observer(function InfluencerOverview({ values, setFieldValue, handleChange, handleBlur }) {
  const [expandInfs, setExpandInfs] = useState(true)
  const [expandInfDetails, setExpandInfDetails] = useState(true)
  const { selectedScenario } = useContext(CampaignContext)

  const actionsByInfluencer = selectedScenario.actions
    .filter(action => action.action_type !== 'non_media_item' && action.visible_in_budget)
    .reduce((object, action) => {
      if(!object[action.influencer_id]) object[action.influencer_id] = []
      object[action.influencer_id].push(action)
      return object
    }, {})

  const actionGroups = Object.values(actionsByInfluencer)

  return (
    <div className="bg-white dark:bg-rb-dark-mode border-1 border-rb-widget-border dark:border-rb-dark-mode-lighter rounded-2xl p-4 mt-4">
      <div className="flex justify-between items-center mb-8">
        <p className="font-bold text-xl dark:text-white">Influencer Overview</p>
        <Switch name="influencer_overview_visible" value={values.influencer_overview_visible} onChange={({ target: { checked }}) => setFieldValue('influencer_overview_visible', checked, true)} eyeSwitch />
      </div>
      {
        values.influencer_overview_visible && (
          <>
            <div className="flex justify-between items-center mb-8">
                <p className="font-bold text-md dark:text-white">Influencer summary</p>
                {expandInfs ? <ChevronDown className="dark:text-white" onClick={() => setExpandInfs(false)} /> : <ChevronUp className="dark:text-white" onClick={() => setExpandInfs(true)} />}
            </div>
            {expandInfs && (
              <>
                <div className="overflow-x-auto pb-4">
                  <table className="min-w-full border-separate border-spacing-0">
                    <thead>
                      <tr className="bg-[#F0F5F4] dark:bg-rb-dark-mode-lighter">
                        <th className="text-sm font-normal text-left border-1 border-border-primary dark:border-rb-dark-mode-lighter px-4 py-2 rounded-tl-lg sticky left-0 z-10 bg-[#F0F5F4] dark:bg-rb-dark-mode-lighter dark:text-white">Name</th>
                        <th className="text-sm font-normal text-left border-1 border-border-primary dark:border-rb-dark-mode-lighter px-4 py-2 dark:text-white">Performance</th>
                        <th className="text-sm font-normal text-left border-1 border-border-primary dark:border-rb-dark-mode-lighter px-4 py-2 dark:text-white">Follower</th>
                        <th className="text-sm font-normal text-left border-1 border-border-primary dark:border-rb-dark-mode-lighter px-4 py-2 dark:text-white">Reach</th>
                        <th className="text-sm font-normal text-left border-1 border-border-primary dark:border-rb-dark-mode-lighter px-4 py-2 dark:text-white">Impressions</th>
                        <th className="text-sm font-normal text-left border-1 border-border-primary dark:border-rb-dark-mode-lighter px-4 py-2 dark:text-white">Likes</th>
                        <th className="text-sm font-normal text-left border-1 border-border-primary dark:border-rb-dark-mode-lighter px-4 py-2 dark:text-white">Comments</th>
                        <th className="text-sm font-normal text-left border-1 border-border-primary dark:border-rb-dark-mode-lighter px-4 py-2 dark:text-white">Saves</th>
                        <th className="text-sm font-normal text-left border-1 border-border-primary dark:border-rb-dark-mode-lighter px-4 py-2 dark:text-white">Eng. Rate</th>
                        <th className="text-sm font-normal text-left border-1 border-border-primary dark:border-rb-dark-mode-lighter px-4 py-2 dark:text-white">Price</th>
                        <th className="text-sm font-normal text-left border-1 border-border-primary dark:border-rb-dark-mode-lighter px-4 py-2 dark:text-white">CPM Follower</th>
                        <th className="text-sm font-normal text-left border-1 border-border-primary dark:border-rb-dark-mode-lighter px-4 py-2 dark:text-white">CPM Impression</th>
                        <th className="text-sm font-normal text-left border-1 border-border-primary dark:border-rb-dark-mode-lighter px-4 py-2 rounded-tr-lg min-w-[100px] dark:text-white">Cost/Eng Rate</th>
                      </tr>
                    </thead>
                    <tbody>
                      {actionGroups.map((actionGroup) => <InfluencerRowStats key={actionGroup[0].influencer_id} infActions={actionGroup} formProps={{ values, setFieldValue, handleChange, handleBlur }} />)}
                    </tbody>
                  </table>
                </div>
                <div className="flex justify-end gap-8">
                  <div className="flex justify-between items-center gap-2">
                    <CheckCircle className="font-bold text-rb-green dark:text-rb-green" />
                    <p className="text-sm dark:text-white">Good</p>
                  </div>
                  <div className="flex justify-between items-center gap-2">
                    <DashCircle className="font-bold text-rb-black dark:text-white" />
                    <p className="text-sm dark:text-white">Average</p>
                  </div>
                </div>
              </>
            )}

            <div className="flex justify-between items-center my-8">
              <p className="font-bold text-md dark:text-white">Influencer details</p>
              {expandInfDetails ? <ChevronDown className="dark:text-white" onClick={() => setExpandInfDetails(false)} /> : <ChevronUp className="dark:text-white" onClick={() => setExpandInfDetails(true)} />}
            </div>
            {expandInfDetails && (
              <>
                {actionGroups.map((actionGroup) => <InfluencerDetails key={actionGroup[0].influencer_id} infActions={actionGroup} formProps={{ values, setFieldValue, handleChange, handleBlur }} pmSide />)}
              </>
            )}
          </>
        )
      }
    </div>
  )
})